/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';

import { sha256 } from 'js-sha256';
import { SettingsService } from '../settings/settings.service';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Booking } from '../../models/booking';
import { FcmMessage } from 'src/app/models/fcmmessage';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public http: HttpClient, public sett: SettingsService) { }

  login(username: string, password: string): Observable<LoginResponse> {
    //?resource=12-Dragan&sender=21956'
    const pwd = sha256(password);

    
    //Do not use argparams
    const p = new HttpParams()
      .set("UserName", username)
      .set("PassWord", pwd)
      .set("version", this.sett.GetLoginVersion());
    return this.http.post<LoginResponse>(this.sett.REST_URL + '/Mobile/Login',p);

    //return this.http.get(url).map(res => res.json());
    //return this.http.get<LoginResponse>(url);
    //return this.http.get<LoginResponse>(url);
  }

  getInstances():Observable<any> {
    const url = this.sett.instanceApiUrl;
    return this.http.get(url);
  }

  getBookingData(resource: string, sender: string): Observable<any> {
    //?resource=12-Dragan&sender=21956'
    const url = this.sett.REST_URL + '/Sodexo/MobileGetOrderList?resource=' + resource +'&sender=' +sender;

    //return this.http.get(url).map(res => res.json());
    return this.http.get(url);
  }

  getFcmMessages(resource: string, sender: string): Observable<FcmMessage[]> {
    const url =
      this.sett.REST_URL +
      '/Mobile/GetFcmMessages?resource=' +
      resource +
      '&sender=' +
      sender;

    return this.http.get<FcmMessage[]>(url);
  }

  sendEvent(
    sender: string,
    id: string,
    command: string,
    msg: string
  ): Observable<any> {
    return this.sendEventToUrl(this.sett.REST_URL, sender, id, command, msg);
  }

  sendEventToUrl(
    baseUrl: string,
    sender: string,
    id: string,
    command: string,
    msg: string
  ): Observable<any> {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const p = new HttpParams()
    .set("sender", sender)
    .set("id", id)
    .set("command", command)
    .set("message", msg)
    .set("mobilesyncdate", new Date().toISOString())
    const url = baseUrl.replace(/\/$/, '') + '/Mobile/MobileSyncJson';
    return this.http.post(url, p);
    //Below cause CORS problems
    // const body = {
    //   sender:sender,
    //   id:id,
    //   command:command,
    //   message:msg,
    //   mobilesyncdate: new Date().toISOString()
    // };
  
    // var urlPost = this.sett.REST_URL + '/Mobile/MobilePostJson';
    
    // return this.http.post(urlPost, body);
  }

  TransferFile(fileName: string, fileURL: string): Promise<unknown> {
    const url = this.sett.REST_URL + '/Mobile/uploadfile';
    const fd = new FormData();
    const file = dataURLtoFile(fileURL, fileName);
    // Using a normal File object does not work on android, so we have to use a blob instead and set the file name manually...
    fd.append("file", file, fileName);
    return fetch(url, {method: 'POST', body: fd, mode: 'cors', });

    // From: https://stackoverflow.com/a/38935990
    function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]), 
          n = bstr.length, 
          u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      // return new File([u8arr], filename, {type:mime});
      return new Blob([u8arr]);
    }
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public PostScans(
    barcodeList: string[],
    eventtypename: string,
    terminalId,
    resource
  ): Observable<any> {
    //TODO: Gör en mobile version av denna
    const url =
      this.sett.REST_URL.replace('/mobile', '') + '/public/postjobitemscans';

    const po = {
      customer: null,
      barcodes: barcodeList,
      terminalid: terminalId,
      eventtype: eventtypename,
      resource
    };

    const p = new HttpParams().set('obj', JSON.stringify(po));

    return this.http.post(url, '', { params: p });
  }

  public UpdatePosition(GeoX: number, GeoY: number, resource: string) {
    const url = this.sett.REST_URL + '/Mobile/UpdatePosition';
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const p = new HttpParams()
      .set('resource', resource)
      .set('x', GeoX.toString())
      .set('y', GeoY.toString());

    return this.http.post(url, '', { params: p });
  }

  public CheckBarcode(sender: string, barcode: string): Observable<any> {
    const url = this.sett.REST_URL + '/Mobile/CheckBarcode';
    const p = new HttpParams()
      .set('sender', sender)
      .set('barcode', barcode);

    return this.http.get(url, { params: p });
  }
}

export interface SettingsKeyValue {
  key: string;
  value: string;
}

export interface LoginResponse {
  Error: string;
  NewVersionUrl: string;
  SessionId: string;
  ResourceList: string;
  FullName: string;
  Terminals: string;
  Settings: [SettingsKeyValue];
  Permissions: [string];
}
